/** Hover underline for stock profile links (matches portfolio name links). */
export const STOCK_LINK_CLASS = "bastion-stock-link";

/** Nested label inside a stock link (flags/icons stay un-underlined). */
export const STOCK_LINK_TEXT_CLASS = "bastion-stock-link-text";

/** Append stock-link class to an existing className string. */
export function withStockLinkClass(className?: string): string {
  return [className, STOCK_LINK_CLASS].filter(Boolean).join(" ");
}
